import React, { useEffect } from 'react';
import { useAudioRecorder } from "react-audio-voice-recorder";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import Microphone from '../../assets/microphone.svg';
import "./AudioRecorder.css";

const AudioRecorder = ({ addAudioElement }) => {
    const {
        startRecording,
        stopRecording,
        togglePauseResume,
        recordingBlob,
        isRecording,
        isPaused,
        recordingTime,
        mediaRecorder
    } = useAudioRecorder();
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    useEffect(() => {
        if (!recordingBlob) return;
        addAudioElement(recordingBlob, transcript)
    }, [recordingBlob])

    const start = () => {
        resetTranscript()
        SpeechRecognition.startListening({ continuous: true })
        startRecording()
    };
    const stop = () => {
        SpeechRecognition.stopListening()
        stopRecording()
    };

    return (
        <div className='input--voice' onClick={isRecording ? stop : start}>
            {isRecording ? (<div className='listening'></div>) : (<img src={Microphone} alt="microphone"/>)}
        </div>
    );
};
export default AudioRecorder;